export const rightArrowIcon = `
<svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.5515 0L19.6842 1.87638L28.9251 11.1607H0V13.8393H28.9215L19.6842 23.1236L21.5515 25L32.1246 14.375L32.1327 14.3856L34 12.5092L21.5515 0Z" fill="#191919"/>
</svg>
`;
